import { CB_BASE_PREFIX, APIResponseWrapper } from '@/api/types'
import { CancelToken } from 'axios'
import { callBackend } from '@/api/callBackend'
import { GenericContentRequest } from 'common/src/api/core/courses/requests'
import { ApiMethod } from 'common/src/api/types'
import { ContentCreatorNotification } from 'common/src/api/contentFrontendVsContentBackend/types'

const PREFIX = CB_BASE_PREFIX + '/notification'

export const getAllNotificationsForCourse = async (
    courseName: string,
    cancelToken: CancelToken = null
): APIResponseWrapper<ContentCreatorNotification[]> => {
    return await callBackend<
        GenericContentRequest,
        ContentCreatorNotification[]
    >(
        PREFIX + '/getAllNotificationsForCourse',
        ApiMethod.GET,
        { courseName },
        cancelToken
    )
}

export const markAllUnseenNotificationsAsSeenForCourse = async (
    courseName: string,
    cancelToken: CancelToken = null
): APIResponseWrapper<void> => {
    return await callBackend<GenericContentRequest, null>(
        PREFIX + '/markAllUnseenNotificationsAsSeenForCourse',
        ApiMethod.POST,
        { courseName },
        cancelToken
    )
}

export const getNotificationQueue = async (
    courseName: string,
    page: number,
    pageSize: number,
    filter: 'all' | 'incomplete' | 'complete',
    sort: 'newest' | 'oldest',
    cancelToken: CancelToken = null
): APIResponseWrapper<{
    notifications: (ContentCreatorNotification & { id: string })[]
    totalCount: number
}> => {
    return await callBackend<
        {
            courseName: string
            page: string
            pageSize: string
            filter: string
            sort: string
        },
        {
            notifications: (ContentCreatorNotification & { id: string })[]
            totalCount: number
        }
    >(
        PREFIX + '/getNotificationQueue',
        ApiMethod.GET,
        {
            courseName,
            page: String(page),
            pageSize: String(pageSize),
            filter,
            sort,
        },
        cancelToken
    )
}

export const toggleNotificationComplete = async (
    courseName: string,
    notificationId: string,
    isCompleted: boolean,
    cancelToken: CancelToken = null
): APIResponseWrapper<void> => {
    return await callBackend<
        { courseName: string; notificationId: string; isCompleted: boolean },
        null
    >(
        PREFIX + '/toggleNotificationComplete',
        ApiMethod.POST,
        { courseName, notificationId, isCompleted },
        cancelToken
    )
}

export const batchToggleNotificationComplete = async (
    courseName: string,
    notificationIds: string[],
    isCompleted: boolean,
    cancelToken: CancelToken = null
): APIResponseWrapper<void> => {
    return await callBackend<
        {
            courseName: string
            notificationIds: string[]
            isCompleted: boolean
        },
        null
    >(
        PREFIX + '/batchToggleNotificationComplete',
        ApiMethod.POST,
        { courseName, notificationIds, isCompleted },
        cancelToken
    )
}

export const updateNotificationNotes = async (
    courseName: string,
    notificationId: string,
    notes: string,
    cancelToken: CancelToken = null
): APIResponseWrapper<void> => {
    return await callBackend<
        { courseName: string; notificationId: string; notes: string },
        null
    >(
        PREFIX + '/updateNotificationNotes',
        ApiMethod.POST,
        { courseName, notificationId, notes },
        cancelToken
    )
}
